import { Component, Inject, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { LoaderComponent } from '../../shared/loader/loader.component';
import { MenuComponent } from '../../shared/menu/menu.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { map, Observable, startWith, Subscription } from 'rxjs';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as nationalData from '../../../assets/national.json';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ApiService } from '../../Core/services/api.service';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { StorageService } from '../../Core/services/storage.service';
import { ToastService } from '../../Core/services/toast.service';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from '../../Core/services/authentication.service';
import { NoResultComponent } from '../../shared/no-result/no-result.component';
interface UserActivity {
  reqNo: string;
  queryType: string;
  status: string;
  date: Date;
  action: string;
}

@Component({
  selector: 'app-crm',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, MenuComponent, NgScrollbarModule, LoaderComponent, NgbPaginationModule, RouterModule, NgxIntlTelInputModule, MatAutocompleteModule, MatInputModule, MatFormFieldModule, BsDatepickerModule, NoResultComponent],
  templateUrl: './crm.component.html',
  styleUrl: './crm.component.scss',
  standalone: true,
  providers: [DatePipe]
})
export class CrmComponent implements OnInit {
  private datePipe = inject(DatePipe);
  menuCollapsed = signal(false);
  loader = false
  opsSameAsCommercial = false;
  finSameAsCommercial = false;
  invSameAsCompany = false;      // Invoicing <- Company
  finSameAsOperations = false;
  CountryISO = CountryISO;
  SearchCountryField = SearchCountryField;
  filteredNationalities: Observable<any[]> = new Observable<any[]>();
  bsValue = new Date();
  showButtons: boolean = true;
  quantrolSignaturePreview: string;


  userActivities: UserActivity[] = [
    {
      reqNo: '#123564',
      queryType: 'Bookings & Payments',
      status: 'Active',
      date: new Date('2025-08-23'),
      action: 'View'
    }
  ];

  activeSection: string = 'registration';
  editMode: boolean = true;
  customerForm: FormGroup;

  currentPage: number = 1;
  pageForm: FormGroup;
  onboardingForm: FormGroup;
  maxsize = 3
  itemsPerPage = 25
  selectedMonths = { 'selectedMonth': [], 'selectedPaidMonth': [], 'selectedCheckIn': [], 'selectedMonthDeadLineDate': [], 'selectedSupplierDueMonth': [] };
  selectedDatesYear = { 'selectedMonth': 2025, 'selectedPaidMonth': 2025, 'selectedCheckIn': 2025, 'selectedMonthDeadLineDate': 2025, 'selectedSupplierDueMonth': 2025 };
  paymentStatuses = ['UNPAID', 'PAID'];
  currency = ['AED', 'GBP', 'USD', 'INR', 'EUR', 'CAD', 'AUD', 'JPY', 'CNY'];
  latestDueDate: Date | null = null;
  isDropdownOpen = {};
  selectedMonth: any
  selectedPaidMonth: any
  months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  years = [2021, 2022, 2023, 2024, 2025]
  periods = [
    { value: 1, label: '1 month' },
    { value: 2, label: '2 months' },
    { value: 3, label: '3 months' },
    { value: 4, label: '4 months' },
    { value: 5, label: '5 months' },
    { value: 6, label: '6 months' },
    { value: 7, label: '7 months' },
    { value: 8, label: '8 months' },
    { value: 9, label: '9 months' },
    { value: 10, label: '10 months' },
    { value: 11, label: '11 months' },
    { value: 12, label: '12 months' }
  ];
  filterMonths = [
    { value: '01', name: 'January' },
    { value: '02', name: 'February' },
    { value: '03', name: 'March' },
    { value: '04', name: 'April' },
    { value: '05', name: 'May' },
    { value: '06', name: 'June' },
    { value: '07', name: 'July' },
    { value: '08', name: 'August' },
    { value: '09', name: 'September' },
    { value: '10', name: 'October' },
    { value: '11', name: 'November' },
    { value: '12', name: 'December' }
  ];
  selectedStatus;
  currentStatus: string = 'STATUS';
  hoverIndex: number | null = null;
  userStatus = [{ value: 0, name: 'Inactive' }, { value: 2, name: 'Active' }, { value: 1, name: 'Partial Active' }];
  allCustomers: any = []
  customerData: any;
  allAgents: any = []
  searchTimeout: any;
  searchText: any;
  modalRef !: BsModalRef
  deletingUser: any;
  selectedCutomer: any;
  selectedCutomerId: any;
  submitted: boolean;
  allowAddRemoval: boolean = false;
  country = new FormControl();
  national: any[] = nationalData?.national;
  private sectionSyncSubs = new Map<string, Subscription>();
  public readonly companyToInvoiceMap: Record<string, string> = {
    tradingName: 'invoiceCompanyName',
    address: 'invoiceAddress',
    country: 'invoiceCountry',
    // add more if needed, e.g. companyEmail: 'invoiceEmail'
  };
  selectedFlag: any;
  selectedValue: any;
  reqAmount: any;
  role: string;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private apiService: ApiService,
    private storageService: StorageService,
    private toastService: ToastService,
    private authService: AuthenticationService,
  ) {
    this.customerForm = this.fb.group({
      firstName: [],
      lastName: [],
      email: [],
      phone: [],
      companyName: [],
      location: [],
      companyWebsite: [],
      businessType: [],
      accountManager: null,
      title: [],
      uplift: [],
      userStatus: [],
    });

    this.onboardingForm = this.fb.group({
      // Date
      date: [null, Validators.required],

      // Company Info
      tradingName: ['', Validators.required],
      ownerName: ['', Validators.required],
      address: ['', Validators.required],
      country: ['', Validators.required],
      businessType: ['', Validators.required],

      // Invoicing
      invoiceCompanyName: ['', Validators.required],
      fiscalNumber: ['', Validators.required],
      trn: ['', Validators.required],
      invoiceCountry: ['', Validators.required],
      invoiceAddress: ['', Validators.required],
      invoiceEmail: ['', [Validators.required, Validators.email]],

      // Commercial
      commercialName: ['', Validators.required],
      commercialPosition: ['', Validators.required],
      commercialPhone: ['', { validators: [Validators.required], updateOn: 'blur' }],
      commercialMobile: ['', { validators: [Validators.required], updateOn: 'blur' }],
      commercialEmail: ['', [Validators.required, Validators.email]],

      // Operations
      operationsName: ['', Validators.required],
      operationsPosition: ['', Validators.required],
      operationsPhone: ['', { validators: [Validators.required], updateOn: 'blur' }],
      operationsMobile: ['', { validators: [Validators.required], updateOn: 'blur' }],
      operationsEmail: ['', [Validators.required, Validators.email]],
      operationsNotificationEmail: ['', [Validators.required, Validators.email]],
      operationsBookingEmail: ['', [Validators.required, Validators.email]],

      // Finance
      financeName: ['', Validators.required],
      financePosition: ['', Validators.required],
      financePhone: ['', { validators: [Validators.required], updateOn: 'blur' }],
      financeMobile: ['', { validators: [Validators.required], updateOn: 'blur' }],
      financeEmail: ['', [Validators.required, Validators.email]],
      financeAddress: ['', Validators.required],
    });

    this.pageForm = this.fb.group({
      value: [1],
    });
  }

  ngOnInit(): void {
    this.loader = true;
    let customerId = this.route.snapshot.queryParams['customerId'];
    if (customerId) this.openEditCRM(customerId, true);
    this.filteredNationalities = this.country?.valueChanges?.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
    this.role = this.storageService.getUserRoles();
    this.getCustomers(customerId);
  }

  getAgentList() {
    if (this.allAgents.length == 0) {
      this.getCustomers(this.selectedCutomerId, true);
    }
  }

  onMenuToggled(isCollapsed: boolean) {
    this.menuCollapsed.set(isCollapsed);
  }

  private _filter(value: string): any[] {
    const filterValue = value?.toLowerCase();
    return this.national?.filter((option) =>
      (
        option?.countryName?.toLowerCase() +
        ' - ' +
        option?.countryCode?.toLowerCase()
      )?.includes(filterValue)
    );
  }

  get f() { return this.onboardingForm.controls; }

  shouldShow(name: string): boolean {
    const c = this.f[name];
    return !!c && (this.submitted || c.touched || c.dirty) && c.invalid;
  }

  viewMasterAgreement(docType: any) {
    this.modalRef = this.modalService.show(docType, {
      class: 'modal-xl modal-dialog-centered agreement-modal',
      // ignoreBackdropClick: true
    });
  }

  getCustomers(customerId?: any, getAgents?: boolean) {
    let params = {
      page: this.currentPage - 1,
      size: 50,
      globalSearch: this.searchText ? this.searchText?.trim() : undefined,
      isActive: (this.selectedStatus || this.selectedStatus == 0) && this.selectedStatus !== 'all' ? this.selectedStatus : undefined,
      roles: (this.router.url.includes('agent') || getAgents) ? ["AGENT"] : undefined
    }
    // his.router.url.includes('agent') ? ["AGENT"]  :
    if (!getAgents) params['businessType'] = this.router.url.includes('inhouse') ? ["inhouse"] : this.router.url.includes('general') ? ["general"] : this.router.url.includes('test') ? ["test"] : undefined;
    this.apiService.getAllUsers(params).subscribe((res: any) => {
      if (res.status) {
        if (!getAgents) {
          this.customerData = res.data;
          this.allCustomers = this.customerData.users || [];
          if (!customerId) this.loader = false
        } else {
          this.allAgents = res.data.users.map((agent: any) => ({ id: agent.id, name: agent.email }));
        }
      } else {
        this.loader = false
        this.toastService.showError(res.message || 'Failed to fetch customers');
        if (res.message == 'JWT token is missing or invalid. Please login.') {
          this.authService.logout();
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['/']);
        }
      }
    }, err => {
      this.loader = false
      this.toastService.showError(err.error.message || 'Failed to fetch customers');
      if (err.error.message == 'JWT token is missing or invalid. Please login.') {
        this.authService.logout();
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/']);
      }
    })
  }

  backToCrm() {
    let url = this.router.url.split('?')[0];
    this.router.navigate([url]);
    this.selectedCutomer = null;
    this.selectedCutomerId = null;
  }

  public readonly commercialToOperationsMap: Record<string, string> = {
    commercialName: 'operationsName',
    commercialPosition: 'operationsPosition',
    commercialPhone: 'operationsPhone',
    commercialMobile: 'operationsMobile',
    commercialEmail: 'operationsEmail',
  };

  public readonly operationsToFinanceMap: Record<string, string> = {
    operationsName: 'financeName',
    operationsPosition: 'financePosition',
    operationsPhone: 'financePhone',
    operationsMobile: 'financeMobile',
    operationsEmail: 'financeEmail',
  };

  firstError(name: string): string | null {
    const c = this.f[name];
    if (!c || !c.errors) return null;
    // priority: required > email > validatePhoneNumber > anything else
    if (c.errors['required']) return 'required';
    if (c.errors['email']) return 'email';
    if (c.errors['validatePhoneNumber']) return 'validatePhoneNumber';
    return Object.keys(c.errors)[0] || null;
  }

  calculateGuestsDisplay(rooms: any[]): string {
    if (!rooms || rooms.length === 0) {
      return '';
    }

    let totalAdults = 0;
    let totalChildren = 0;
    let childAges: number[] = [];

    // Calculate totals from all rooms
    rooms.forEach(room => {
      totalAdults += room.adults || 0;
      totalChildren += room.children || 0;

      // Collect child ages if they exist
      if (room.childAges && Array.isArray(room.childAges)) {
        childAges = [...childAges, ...room.childAges];
      }
    });

    // Build display string
    let result = '';

    // Adults part
    if (totalAdults === 1) {
      result = '1 Adult';
    } else if (totalAdults > 1) {
      result = `${totalAdults} Adults`;
    }

    // Children part
    if (totalChildren > 0) {
      if (result) {
        result += ', ';
      }

      if (totalChildren === 1) {
        result += '1 Child';
      } else {
        result += `${totalChildren} Children`;
      }

      // Add ages if available
      if (childAges.length > 0) {
        const agesString = childAges.map(age => age.toString().padStart(2, '0')).join(', ');
        result += ` (${agesString})`;
      }
    }

    return result;
  }

  dateFormatChange(event: any) {
    let date = event
    if (date) {
      const checkOutformattedDate = this.datePipe.transform(
        date,
        'dd/MM/yyyy'
      );
      this.onboardingForm.get('date')?.setValue(checkOutformattedDate);
    }
  }


  uploadAgreement() {
    this.selectedCutomer.setUpFormInfo.formData.agreement['rateloc_signature_base64'] = this.quantrolSignaturePreview;
    // this.selectedCutomer.setUpFormInfo.formData.agreement['clientSignaturePreview'] = this.clientSignaturePreview;
    this.selectedCutomer.setUpFormInfo.formData.clientData['uploadDate'] = new Date().toISOString();
  }

  exportToPDF(): void {
    const doc = new jsPDF();

    // Add title
    doc.setFontSize(5);
    doc.text('CRM Report', 14, 22);

    // Prepare table data
    const tableColumn = ['ID', 'BUISNESS NAME', 'LOCATION', 'EMAIL', 'WALLET BALANCE', 'BOOKINGS', 'CURRENCY', 'LAST LOGIN', 'STATUS', 'CREATED DATE'];
    const tableRows: any[] = [];

    this.allCustomers.forEach(customer => {
      const customerData = [
        customer.id,
        customer.businessName,
        customer.location,
        customer.email,
        customer.walletBalance || 0,
        customer.bookings || 0,
        ,
        customer.currency || '',
        customer.lastLogin ? new Date(customer.lastLogin).toLocaleDateString('en-GB') : '',
        customer.status == 2 ? 'Active' : customer.status == 0 ? 'Inactive' : 'Partial Active',
        customer.createdDate ? new Date(customer.lastLogin).toLocaleDateString('en-GB') : ''
      ];
      tableRows.push(customerData);
    });

    // Generate PDF table
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      theme: 'striped',
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 5,
        fontStyle: 'bold'
      },
      bodyStyles: {
        fontSize: 5
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      margin: { top: 30, left: 14, right: 14, bottom: 20 },
      didDrawPage: (data) => {
        // Add page numbers
        const pageCount = (doc as any).internal.getNumberOfPages();
        doc.setFontSize(10);
        doc.text(`Page ${data.pageNumber} of ${pageCount}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
      }
    });

    // Save the PDF
    doc.save(`crm.pdf`);
  }

  exportToExcel(): void {
    const excelData = this.allCustomers.map(customer => ({
      'ID': customer.id || '',
      'BUISNESS NAME': customer.businessName || '',
      'LOCATION': customer.location || '',
      'EMAIL': customer.email || '',
      'WALLET BALANCE': customer.walletBalance || 0,
      'BOOKINGS': customer.bookings || '',
      'Currency': customer.currency || '',
      'LAST LOGIN': customer?.lastLogin ? new Date(customer?.lastLogin)?.toLocaleDateString('en-GB') : 'NA',
      'STATUS': customer.status == 2 ? 'Active' : customer.status == 0 ? 'Inactive' : 'Partial Active',
      'CREATED DATE': customer?.createdDate ? new Date(customer?.createdDate)?.toLocaleDateString('en-GB') : ''
    }));

    // Create workbook and worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    // Set column widths
    const colWidths = [
      { wch: 9 }, // Month
      { wch: 15 }, // Bill Name
      { wch: 20 }, // Bill ID
      { wch: 10 }, // Bill Type
      { wch: 9 }, // Amount
      { wch: 7 }, // Currency
      { wch: 10 }, // Paid Status
      { wch: 10 }, // Paid Status
      { wch: 10 }, // Paid Status
    ];
    ws['!cols'] = colWidths;

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'CRM');

    // Generate Excel file buffer
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Save the file
    this.saveExcelFile(excelBuffer, 'crm');
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);
  }

  onSignatureSelected(event: Event, user: any) {
    const file = (event.target as HTMLInputElement)?.files?.[0];
    if (!file) return;

    // ✅ size validation (must be < 2MB)
    if (file.size > 2 * 1024 * 1024) {
      alert('Signature must be less than 2 MB');
      return;
    }

    // ✅ preview
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      this.quantrolSignaturePreview = result;
    };
    reader.readAsDataURL(file);
  }

  downloadAgreementPDF() {
    const element = document.querySelector('.pdf-container') as HTMLElement;
    const downloadButton = element?.querySelector('.doc-buttons') as HTMLElement;
    // const container = element.querySelector('.company-details-container') as HTMLElement;
    element.style.height = 'auto';
    element.style.overflow = 'visible';

    // Store original styles
    const originalStyles = {
      display: element.style.display,
      position: element.style.position,
      left: element.style.left,
      top: element.style.top,
      buttonDisplay: downloadButton?.style.display || ''
    };

    // Hide the download button
    if (downloadButton) {
      downloadButton.style.display = 'none';
    }
    this.showButtons = false;
    // Position off-screen but visible for html2canvas
    element.style.display = 'block';
    element.style.position = 'absolute';
    element.style.left = '-9999px';
    element.style.top = '0';
    element.style.width = '210mm';
    element.style.backgroundColor = 'white';

    const options = {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      width: element.scrollWidth,
      height: element.scrollHeight
    };

    html2canvas(element, options).then(canvas => {
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = 210;
      const pageHeight = 297;

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * pageWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add additional pages
      while (heightLeft >= 0) {
        position -= pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`Client_Agreement_${new Date().toISOString().split('T')[0]}.pdf`);

      // Restore all original styles including button
      this.restoreElementStyles(element, downloadButton, originalStyles);
    }).catch(error => {
      console.error('Error generating PDF:', error);
      this.restoreElementStyles(element, downloadButton, originalStyles);
    });
  }

  private restoreElementStyles(element: HTMLElement, downloadButton: HTMLElement, originalStyles: any) {
    element.style.display = originalStyles.display;
    element.style.position = originalStyles.position;
    element.style.left = originalStyles.left;
    element.style.top = originalStyles.top;
    element.style.height = '600px';
    element.style.overflowY = 'scroll';
    this.showButtons = true
    this.onClose();

    if (downloadButton) {
      downloadButton.style.display = originalStyles.buttonDisplay;
    }
  }

  goToAgreement() {
    this.submitted = true;                 // gate errors from now on
    if (this.onboardingForm.invalid) {
      this.onboardingForm.markAllAsTouched();
      return;
    }

    // const today = this.formatDateForPdf(new Date());

    // this.agreementForm.patchValue({
    //   client_signed_by: this.onboardingForm.value.commercialName || '',
    //   client_position: this.onboardingForm.value.commercialPosition || '',
    //   client_date: today
    // });

    // this.showSetupForm = false;
    // this.showMasterAgreement = true;
  }

  onCountryInput(event: Event) {
    const value = (event.target as HTMLInputElement)?.value ?? '';
    this.onboardingForm.get('country')?.setValue(value, { emitEvent: true, onlySelf: true });
  }
  onInvoiceCountryInput(event: Event) {
    const value = (event.target as HTMLInputElement)?.value ?? '';
    this.onboardingForm.get('invoiceCountry')?.setValue(value, { emitEvent: true, onlySelf: true });
  }

  // When a country is chosen from the dropdown
  onCountrySelected(value: string) {
    // Value format: "CountryName - CC"
    this.onboardingForm.get('invoiceCountry')?.setValue(value);
    // this.onboardingForm.get('country')?.setValue(value);
    // If you want to store the code elsewhere, you can parse it:
    // const code = value.split(' - ')[1];
    // sessionStorage.setItem('selectedCountryCode', code);
  }

  setActiveSection(section: string): void {
    this.activeSection = section;
  }

  toggleSectionSameAs(map: Record<string, string>, checked: boolean) {
    // Clean any previous subscriptions for this relation
    Object.entries(map).forEach(([fromName, toName]) => {
      const key = `${fromName}->${toName}`;
      this.sectionSyncSubs.get(key)?.unsubscribe();
      this.sectionSyncSubs.delete(key);
    });

    Object.entries(map).forEach(([fromName, toName]) => {
      const fromCtrl = this.onboardingForm.get(fromName);
      const toCtrl = this.onboardingForm.get(toName);
      if (!fromCtrl || !toCtrl) return;

      if (checked) {
        // Copy now
        toCtrl.setValue(fromCtrl.value, { emitEvent: false });

        // Disable target while linked
        toCtrl.disable({ emitEvent: false });
        toCtrl.updateValueAndValidity({ emitEvent: false });

        // Live sync from source -> target
        const sub = fromCtrl.valueChanges.subscribe(v => {
          toCtrl.setValue(v, { emitEvent: false });
        });
        this.sectionSyncSubs.set(`${fromName}->${toName}`, sub);
      } else {
        // Unlink: keep last copied value, just re-enable
        toCtrl.enable({ emitEvent: false });
        toCtrl.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  toggleEditMode(): void {
    //   this.editMode = !this.editMode;
    //   if (this.editMode) {
    //     this.customerForm.patchValue(this.customer);
    //   }
  }

  saveCustomer(): void {
    if (this.customerForm.valid) {
      // Simulate API call
      this.editMode = false;
    }
  }

  cancelEdit(): void {
    this.editMode = false;
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'approved':
        return 'status-approved';
      case 'confirmed':
        return 'status-confirmed';
      case 'pending':
        return 'status-pending';
      case 'active':
        return 'status-active';
      case 'failed':
        return 'status-failed';
      case 'rejected':
        return 'status-failed';
      case 'reject':
        return 'status-failed';
      case 'cancelled':
        return 'status-failed';
      case 'retry':
        return 'status-failed';
      default:
        return 'status-default';
    }
  }

  onSupplierAction() {
    this.allowAddRemoval = !this.allowAddRemoval;
  }

  formatCurrency(amount: number, currency: string = 'AED'): string {
    return `${amount.toFixed(2)} ${currency}`;
  }

  formatDate(date: Date): string {
    return date ? date.toLocaleDateString('en-GB') : '';
  }

  onSearchChange() {
    // Clear previous timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Set new timeout
    this.searchTimeout = setTimeout(() => {
      this.loader = true;
      this.currentPage = 1;
      this.getCustomers();
    }, 800); // 300ms delay
  }

  onClose() {
    this.modalRef?.hide();
    this.deletingUser = null
  }

  onDeleteConfirm() {
    console.log('Deleting user with ID:', this.deletingUser.id);
    this.modalRef?.hide();
    this.deletingUser = null
  }

  toggleDatesDropdown(type: any) {
    const wasOpen = this.isDropdownOpen[type];

    Object.keys(this.isDropdownOpen).forEach(key => {
      this.isDropdownOpen[key] = false;
    });

    this.isDropdownOpen[type] = !wasOpen;
  }

  toggleMonth(monthValue: any, year: any, type: any) {
    if (monthValue === 'all') {
      this.selectedMonths[type] = [];
      this.applyMonthSelection(type)
    } else {
      // if (this.selectedMonths[type].includes(year + '-' + monthValue)) {
      if (this.selectedMonths[type].includes(monthValue)) {
        // this.selectedMonths[type] = this.selectedMonths[type].filter(m => m !== monthValue && m !== 'all');
        // let index = this.selectedMonths[type].indexOf(year + '-' + monthValue);
        let index = this.selectedMonths[type].indexOf(monthValue);
        if (index > -1) {
          this.selectedMonths[type].splice(index, 1);
        }
      } else {
        if (this.selectedMonths[type].length < this.months.length) {
          // this.selectedMonths[type].push(year + '-' + monthValue);
          this.selectedMonths[type].push(monthValue);
          // this.selectedMonths[type] = [ ...this.months.map(m => m.value)];
        }
      }
    }
  }

  applyMonthSelection(type: any) {
    // this.toggleDatesDropdown(type);
    this.loader = true;
    this.currentPage = 1;
    if (this.selectedMonths[type].length === 0) {
      this[type] = null;
    } else {
      this[type] = this.selectedMonths[type]
        .filter(m => m !== 'all')
        .map(month => month + '-' + this.selectedDatesYear[type]);
    }
    this.getCustomers();
  }

  isMonthSelected(monthValue: any, year: any, type: any): boolean {
    // return this.selectedMonths[type]?.includes(year + '-' + monthValue) ||
    return this.selectedMonths[type]?.includes(monthValue) ||
      (monthValue === 'all');
  }

  filterStatus(eve: any) {
    this.selectedStatus = eve;
    if (eve === 'all' || eve === 'Status') {
      this.currentStatus = 'STATUS';
    }
    this.currentStatus = eve == '2' ? 'Active' : eve == '0' ? 'Inactive' : 'Partial Active';
    this.currentPage = 1;
    this.loader = true;
    this.getCustomers();
  }

  upliftCheck() {
    setTimeout(() => {
      if(this.customerForm.value.uplift < 0) {
        this.customerForm.patchValue({ uplift: 0 });
      } else if(this.customerForm.value.uplift > 20) {
        this.customerForm.patchValue({ uplift: 20 });
      }
    },100)
  }

  openEditCRM(customerId, directSelected?: boolean) {
    if (!directSelected) {
      this.router.navigate([this.router.url], {
        queryParams: { customerId: customerId },
        queryParamsHandling: 'merge', // Keeps other query params if any
        replaceUrl: true,
      });
    }
    if(this.allAgents?.length < 1) this.getAgentList()
    this.loader = true
    this.apiService.fetchContactById(customerId).subscribe((res: any) => {
      if (res.status) {
        this.selectedCutomerId = customerId;
        this.selectedCutomer = res.data;
        // this.selectedCutomer.userAccInfo.accManager = {id:this.selectedCutomer.userAccInfo.accManager, name: 'Mahesh Shedge'};
        this.selectedCutomer.allSuppList = this.selectedCutomer.allSuppList.map(supplier => ({
          ...supplier,
          isActive: this.selectedCutomer.activeSuppList.some(active => active.supplier_id === supplier.supplierId)
        }));
        console.log(this.selectedCutomer);
        if (this.selectedCutomer?.setUpFormInfo?.formData?.clientData?.tradingName) {
          this.onboardingForm.patchValue({
            // Commercial Information
            tradingName: this.selectedCutomer.setUpFormInfo.formData.clientData.tradingName,
            ownerName: this.selectedCutomer.setUpFormInfo.formData.clientData.ownerName,
            address: this.selectedCutomer.setUpFormInfo.formData.clientData.address,
            country: this.selectedCutomer.setUpFormInfo.formData.clientData.country,
            businessType: this.selectedCutomer.setUpFormInfo.formData.clientData.businessType,

            // Invoice Information
            invoiceCompanyName: this.selectedCutomer.setUpFormInfo.formData.clientData.invoiceCompanyName,
            fiscalNumber: this.selectedCutomer.setUpFormInfo.formData.clientData.fiscalNumber,
            trn: this.selectedCutomer.setUpFormInfo.formData.clientData.trn,
            invoiceCountry: this.selectedCutomer.setUpFormInfo.formData.clientData.invoiceCountry,
            invoiceAddress: this.selectedCutomer.setUpFormInfo.formData.clientData.invoiceAddress,
            invoiceEmail: this.selectedCutomer.setUpFormInfo.formData.clientData.invoiceEmail,

            // Commercial Contact Details
            commercialName: this.selectedCutomer.setUpFormInfo.formData.clientData.commercialName,
            commercialPosition: this.selectedCutomer.setUpFormInfo.formData.clientData.commercialPosition,
            commercialPhone: this.selectedCutomer.setUpFormInfo.formData.clientData.commercialPhone,
            commercialMobile: this.selectedCutomer.setUpFormInfo.formData.clientData.commercialMobile,
            commercialEmail: this.selectedCutomer.setUpFormInfo.formData.clientData.commercialEmail,

            // Operations Contact Details
            operationsName: this.selectedCutomer.setUpFormInfo.formData.clientData.operationsName,
            operationsPosition: this.selectedCutomer.setUpFormInfo.formData.clientData.operationsPosition,
            operationsPhone: this.selectedCutomer.setUpFormInfo.formData.clientData.operationsPhone,
            operationsMobile: this.selectedCutomer.setUpFormInfo.formData.clientData.operationsMobile,
            operationsEmail: this.selectedCutomer.setUpFormInfo.formData.clientData.operationsEmail,
            operationsNotificationEmail: this.selectedCutomer.setUpFormInfo.formData.clientData.operationsNotificationEmail,
            operationsBookingEmail: this.selectedCutomer.setUpFormInfo.formData.clientData.operationsBookingEmail,

            // Finance Contact Details
            financeName: this.selectedCutomer.setUpFormInfo.formData.clientData.financeName,
            financePosition: this.selectedCutomer.setUpFormInfo.formData.clientData.financePosition,
            financePhone: this.selectedCutomer.setUpFormInfo.formData.clientData.financePhone,
            financeMobile: this.selectedCutomer.setUpFormInfo.formData.clientData.financeMobile,
            financeEmail: this.selectedCutomer.setUpFormInfo.formData.clientData.financeEmail,
            financeAddress: this.selectedCutomer.setUpFormInfo.formData.clientData.financeAddress,

            // Dates
            // uploadDate: this.selectedCutomer.setUpFormInfo.formData.clientData.uploadDate,
            date: this.selectedCutomer.setUpFormInfo.formData.clientData.date,

            // Agreement
          });
        }
        this.customerForm.patchValue({
          firstName: this.selectedCutomer.userAccInfo.firstName,
          lastName: this.selectedCutomer.userAccInfo.lastName,
          email: this.selectedCutomer.userAccInfo.email,
          phone: this.selectedCutomer.userAccInfo.phoneNumber,
          companyName: this.selectedCutomer.userAccInfo.companyName,
          location: this.selectedCutomer.userAccInfo.nationality,
          companyWebsite: this.selectedCutomer.userAccInfo.companyWebsite,
          businessType: this.selectedCutomer.userAccInfo.businessType,
          accountManager: this.selectedCutomer.userAccInfo.accManager ? this.selectedCutomer.userAccInfo.accManager : null ,
          title: this.selectedCutomer.userAccInfo.title,
          userStatus: this.selectedCutomer.userAccInfo.isActive,
          uplift: this.selectedCutomer.userAccInfo.uplift,
        });
        this.loader = false
      }
    })
  }

  submitSuppliers() {
    this.modalRef?.hide();

  }

  openModal(modal: any, size: any, item?: any,) {
    this.modalRef = this.modalService.show(modal, {
      class: size,
    });
    this.deletingUser = item;
    console.log(name);

    // let confirmed :any = confirm('Are you sure ?');
  }

  openSubmitModal(modal: any, flag: any, value: any, walletAction?: any) {
    this.modalRef?.hide();
    this.selectedFlag = flag;
    this.selectedValue = value;
    if (this.selectedFlag == 'setUpFormInfo' && (this.quantrolSignaturePreview)) {
      this.selectedValue.formData.agreement['rateloc_signature_base64'] = this.quantrolSignaturePreview;
      this.selectedValue.formData.clientData['uploadDate'] = new Date().toISOString();
    }
    if (walletAction) this.selectedValue['walletAction'] = walletAction;
    this.modalRef = this.modalService.show(modal, {
      class: 'modal-xl modal-dialog-centered',
    });

    // this.onSubmit(flag,value)
  }

  onSubmit() {
    let obj
    if (this.selectedFlag == 'removeSupplier' || this.selectedFlag == 'addSupplier') {
      obj = {
        flag: this.selectedFlag,
        supplierId: this.selectedValue.supplierId
      };
    }
    if (this.selectedFlag == 'walletStatus') {
      obj = {
        flag: this.selectedFlag,
        requestId: this.selectedValue.request,
        walletStatus: this.selectedValue.walletAction,
      };
    }
    if (this.selectedFlag == 'register') {
      obj = {
        "firstName": this.selectedValue.firstName,
        "lastName": this.selectedValue.lastName,
        "phoneNumber": this.selectedValue.phone,
        "title": this.selectedValue.title,
        "isActive": this.selectedValue.userStatus,
        "accManger": this.selectedValue.accountManager,
        "uplift": this.selectedValue.uplift,
      };
    }
    if (this.selectedFlag == 'addAmount') {
      obj = {
        "flag": this.selectedFlag,
        "walletAmount": this.reqAmount,
        "walletStatus": "Approved"
      };
    }
    if ((this.selectedFlag == 'setUpForm') && this.quantrolSignaturePreview) {
      obj = {
        "formId": this.selectedValue?.id ? this.selectedValue?.id : undefined,
        "formData": this.selectedValue.formData,
        "flag": this.selectedFlag,
      };
    } else if ((this.selectedFlag == 'setUpForm') && !this.quantrolSignaturePreview) {
      if(this.onboardingForm.invalid) {
        this.toastService.showError('Please provide all required fields');
        return;
      }
      obj = {
        // userId:this.contactId,
        "formId": this.selectedCutomer.setUpFormInfo?.id ? this.selectedCutomer?.setUpFormInfo?.id : undefined,
        "flag": this.selectedFlag,
        address: this.selectedValue.invoiceAddress,
        // email: this.selectedValue.invoiceEmail,
        formData: {
          clientData: {
            tradingName: this.selectedValue.tradingName,
            ownerName: this.selectedValue.ownerName,
            address: this.selectedValue.address,
            country: this.selectedValue.country,
            businessType: this.selectedValue.businessType,
            invoiceCompanyName: this.selectedValue.invoiceCompanyName,
            fiscalNumber: this.selectedValue.fiscalNumber,
            trn: this.selectedValue.trn,
            invoiceCountry: this.selectedValue.invoiceCountry,
            invoiceAddress: this.selectedValue.invoiceAddress,
            invoiceEmail: this.selectedValue.invoiceEmail,
            commercialName: this.selectedValue.commercialName,
            commercialPosition: this.selectedValue.commercialPosition,
            commercialPhone: this.selectedValue.commercialPhone,
            commercialMobile: this.selectedValue.commercialMobile,
            commercialEmail: this.selectedValue.commercialEmail,
            operationsName: this.selectedValue.operationsName,
            operationsPosition: this.selectedValue.operationsPosition,
            operationsPhone: this.selectedValue.operationsPhone,
            operationsMobile: this.selectedValue.operationsMobile,
            operationsEmail: this.selectedValue.operationsEmail,
            operationsNotificationEmail: this.selectedValue.operationsNotificationEmail,
            operationsBookingEmail: this.selectedValue.operationsBookingEmail,
            financeName: this.selectedValue.financeName,
            financePosition: this.selectedValue.financePosition,
            financePhone: this.selectedValue.financePhone,
            financeMobile: this.selectedValue.financeMobile,
            financeEmail: this.selectedValue.financeEmail,
            financeAddress: this.selectedValue.tradingName,
            uploadDate: this.selectedValue.uploadDate,
            date: this.datePipe.transform(
              this.selectedValue.date,
              'dd/MM/yyyy'
            )
          },
          agreement: {
            client_signed_by: '',
            client_date: '',
            client_position: '',
            client_signature_base64: '',
            rateloc_signature_base64: '',
          }
        },
      }
    }
    let role = this.storageService.getUserRoles();
    if (['OWNER', 'MASTER_ADMIN'].includes(role)) obj['tenantKey'] = this.storageService.getTenantKey();
    this.apiService.updateContact(obj, this.selectedCutomerId).subscribe((res: any) => {
      if (res.status) {
        this.modalRef?.hide();
        this.toastService.showSuccess('Success', res.message);
        this.loader = true;
        this.openEditCRM(this.selectedCutomerId);
        // this.getCustomers()
        // this.backToCrm();
      } else {
        this.toastService.showError(res.message);
      }
    }, error => { this.toastService.showError(error.error.message); })
  }

  onlyNumbers(event: any, input?:any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow: backspace, delete, tab, escape, enter
    // Only allow numbers
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    if(input == 'uplift') this.upliftCheck()
    return true;
  }

  onPageChange(page: number) {
    this.loader = true;
    this.currentPage = page;
    if (page > this.customerData.totalPages) {
      this.pageForm.controls['value'].setValue(this.customerData.totalPages);
    }
    this.getCustomers();
  }

  removeCustomer(id: string) {
    console.log('Customer removed');
  }

}
